export default function http($httpProvider) {
    $httpProvider.useApplyAsync(true);
}

http.$inject = ['$httpProvider'];



// WEBPACK FOOTER //
// ./src/javascripts/ng-admin/Main/config/http.js